import React, { useEffect, useState, useRef } from "react"
import moment from "moment"
import PatientChip from "../PatientChip"
import "./DayView.scss"
import AppointmentCalendarUtils from "../../AppointmentCalenderUtils"
import { Button } from "@mui/material"

export default function DayView({
  includeIpdOpdDivision,
  currentlySelected,
  appointments,
  onButtonClick,
  outline,
  userRole,
  slots,
  slotDuration,
  bedSlotDuration,
  show,
  reloadAppointments
}: any) {
  const IPDwidthReference = useRef<any>(null);
  const OPDwidthReference = useRef<any>(null);
  const [width, setWidth] = useState({ ipd: 0, opd: 0 })
  const [currentTime, setCurrentTime] = useState(moment()?.format('hh:mm a'))

  useEffect(() => {
    const intervalId: any = setInterval(() => {
      const current = moment()?.format('hh:mm a')
      setCurrentTime(current)
    }, (slotDuration * 60 * 60) - 20000)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  useEffect(() => {
    let IPDView = IPDwidthReference.current
    let OPDView = OPDwidthReference.current
    setWidth({ ipd: IPDView?.scrollWidth, opd: OPDView?.scrollWidth })
  }, [appointments?.length, userRole])

  function renderPatientChip(eachSlot: any, type: any = null, difference?: any) {
    let currentSlot = moment(eachSlot, "hh:mm a").format("HH:mm")
    let findPatients = appointments?.filter((eachApp: any) => {
      if (eachApp?.appointmentType === "IPD") {
        eachApp?.allottedBed?.slots?.sort(function (a: any, b: any) {
          return a > b
        })
        return eachApp?.allottedBed?.slots && eachApp?.allottedBed?.slots[0] === currentSlot;
      } else {
        eachApp?.slots?.sort(function (a: any, b: any) {
          return a > b
        })
        return eachApp?.slots && eachApp?.slots[0] === currentSlot
      }
    })

    if (type !== null) {
      findPatients = findPatients?.filter(
        (eachApp: any) => eachApp?.appointmentType === type
      )
    }

    let slotsIn = findPatients?.map((item: any) => {
      return item?.appointmentType === "IPD" ? item?.allottedBed?.slots : item["slots"]
    })
    var merged: any = [].concat.apply([], slotsIn)

    return (
      <>
        {merged?.includes(currentSlot) ? (
          <div
            className="col-md-12 col-lg-12 d-flex wrapper"
            style={{
              position: "relative", scrollBehavior: "smooth",
            }}
          >
            <div
              className="border-line-wrapper"
              style={{ position: "absolute", top: "12px", width: type === "OPD" ? width?.opd + "px" : type === "IPD" ? width?.ipd + "px" : "" }}
            >
              <div className={`border-line ${difference >= 0 && difference < slotDuration ? "highlight" : ""}`} />
            </div>
            {findPatients?.map((eachPatient: any) => (
              <div key={eachPatient?.id} className="patient">

                <PatientChip
                  patient={eachPatient}
                  onButtonClick={onButtonClick}
                  disablePopup={includeIpdOpdDivision}
                  // height={eachPatient?.allottedBed?.slots?.length || eachPatient.slots?.length}
                  height={eachPatient.slots?.length ? eachPatient.slots?.length : eachPatient?.allottedBed?.slots?.length ? ((bedSlotDuration / slotDuration) * eachPatient?.allottedBed?.slots?.length) : 1}
                  outline={outline}
                  reloadAppointments={reloadAppointments}
                  userRole={userRole}
                  slotDuration={slotDuration}
                  bedSlotDuration={bedSlotDuration}
                  showModal={show}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="wrapper">
            <div className="border-line-wrapper" style={{ height: "26px", width: type === "OPD" ? width?.opd + "px" : type === "IPD" ? width?.ipd + "px" : "" }}>
              <div className={`border-line ${difference >= 0 && difference < slotDuration ? "highlight" : ""}`} />
            </div>
          </div >
        )}
      </>
    )
  }
  /**************************old code of rendering each row in calender starts here************************************ */
  function renderEachRow(eachSlot: any, index: any) {
    return includeIpdOpdDivision ? (
      <div className="col-md-12 col-lg-12 m-0 row division">
        <div className="col-md-6 col-lg-6 tab">{renderPatientChip(eachSlot, "OPD")}</div>
        <div className="col-md-6 col-lg-6">{renderPatientChip(eachSlot, "IPD")}</div>
      </div>
    ) : (
      renderPatientChip(eachSlot, null)
    )
  }
  /**************************old code of rendering each row in calender ends here ************************************ */

  function renderIncludeIpdOpdDivision(slots: any) {
    return (
      <div className="col-md-12 col-lg-12 m-0 row division" ref={OPDwidthReference}>
        <div className="col-md-6 col-lg-6 tab width-reference" style={{ overflow: "scroll" }}>
          {
            slots?.map((eachSlot: any, index: any) => {
              const time1 = moment(eachSlot, 'h:mm A');
              const time2 = moment(currentTime, 'h:mm A');
              const differenceInMinutes = time2?.diff(time1, 'minutes');
              return renderPatientChip(eachSlot, "OPD", differenceInMinutes)
            })
          }
        </div>
        <div className="col-md-6 col-lg-6 width-reference" ref={IPDwidthReference} style={{ overflow: "scroll" }}>
          {
            slots?.map((eachSlot: any, index: any) => {
              const time1 = moment(eachSlot, 'h:mm A');
              const time2 = moment(currentTime, 'h:mm A');
              const differenceInMinutes = time2?.diff(time1, 'minutes');
              return renderPatientChip(eachSlot, "IPD", differenceInMinutes)
            })
          }
        </div>
      </div>
    )
  }

  function renderDayView() {
    return (
      <div className="day-view-wrapper">
        {
          includeIpdOpdDivision

            ? (
              <div className="col-md-12 col-lg-12 row inner-tab-wrapper">
                <div className="col-md-1 col-lg-1 p-0"></div>
                <div className="col-md-11 col-lg-11 p-0">
                  <div className="col-md-12 col-lg-12 m-0 row">
                    <div className="col-md-6 col-lg-6 tab">
                      OPD[
                      {AppointmentCalendarUtils.fetchCountData(
                        appointments,
                        currentlySelected,
                        "OPD"
                      )}
                      ]
                    </div>
                    <div className="col-md-6 col-lg-6 tab">
                      IPD[
                      {AppointmentCalendarUtils.fetchCountData(
                        appointments,
                        currentlySelected,
                        "IPD"
                      )}
                      ]
                    </div>
                    <div>
                      {/* <Button text="special request" onClick={() => currentlySelected === "SPR"} /> */}
                      {/* <button onClick={() => currentlySelected === "SPR"}>Special Request</button> */}
                    </div>

                  </div>
                </div>
              </div>
            ) : null}
        <div className="slots-wrapper">
          <div className="d-flex col-md-12 col-lg-12 p-0 dayview">
            <div className="col-md-1 col-lg-1 p-0">
              {
                slots?.map((eachSlot: any) => {
                  const time1 = moment(eachSlot, 'h:mm A');
                  const time2 = moment(currentTime, 'h:mm A');
                  const differenceInMinutes = time2?.diff(time1, 'minutes');
                  return (
                    <div
                      className={`timing ${differenceInMinutes >= 0 && differenceInMinutes < slotDuration ? "highlightBg" : ""}`}
                      style={{}}
                    >
                      {eachSlot}
                    </div>
                  )
                })
              }
            </div>

            <div className="col-md-11 col-lg-11 p-0 slots-view">
              {
                includeIpdOpdDivision ?
                  renderIncludeIpdOpdDivision(slots)
                  :
                  slots?.map((eachSlot: any, index: any) => {
                    const time1 = moment(eachSlot, 'h:mm A');
                    const time2 = moment(currentTime, 'h:mm A');
                    const differenceInMinutes = time2?.diff(time1, 'minutes');
                    return renderPatientChip(eachSlot, null, differenceInMinutes)
                  })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  return renderDayView()
}
